module.exports = __webpack_public_path__ + "resources/img/img-acra-point-02-jp.73bb3453adb7d8f67f67bb91cf00ef86.png";